import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Storage } from '@ionic/storage';
import { ToastController, LoadingController } from 'ionic-angular';
import { Facebook, FacebookLoginResponse } from '@ionic-native/facebook';
import { UniqueDeviceID } from '@ionic-native/unique-device-id';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';



@Injectable()
export class UserProvider {

  public loggedIn: any;
  public deviceId: any;
  private fbLoginInterval: any;
  userData:any;

  constructor(public http: Http, 
    public toastCtrl: ToastController,
    public storage: Storage,
    private uniqueDeviceID: UniqueDeviceID,
    public fb: Facebook) {
    
  }

  load(){
    return new Promise((resolve, reject)=>{
      resolve();
    });
  }

  logout(){}

  getAccessData(){
    return [];
  }

  setAccessData(data){}

  clearAccessData(){}

  setHomePage(homepage){}

  setMenu(menu){}

  loginFacebook(){
    return new Promise((resolve, reject)=>{
      this.fb.login(['email', 'public_profile']).then((response: FacebookLoginResponse) => {     
        // do something with the response here?  
        this.fb.api('me?fields=id,name,email,first_name', []).then(profile => {
          //this.fbProfile = {email: profile['email'], first_name: profile['first_name'], username: profile['name']}
          profile.deviceId = this.deviceId;
          this.loggedIn = true;
          this.save(profile);
          this.userData = profile;
          resolve(profile);
          //this.userObj = JSON.stringify(profile);
        }).catch((e) => {
          console.log('Error querying FB api', e);
          reject(e);
        });
      })
      .catch((e) => {
        console.log('Error logging into Facebook', e);
        reject(e);
      });
    });      
  }

  checkFbLogin(){
    if(!this.loggedIn) return;
    this.fb.getLoginStatus().then(res => {
      console.log('checking fb login', res.status);

      let toast = this.toastCtrl.create({
        message: 'fb login status: ' + res.status,
        duration: 1000
      });
      toast.present();
      if(res.status === 'connected'){
        var uid = res.authResponse.userID;
        var accessToken = res.authResponse.accessToken;
      } else if (res.status === 'not_authorized') {
        // the user is logged in to Facebook, 
        // but has not authenticated your app
        this.logout(); // subscribed to in the app so should resetToInit automatically
      } else {
        // the user isn't logged in to Facebook.
        // do we reset here too?
      }
      
    }).catch(err=>{
      console.log('failed to check FB login status', err);
      // offline?
      let toast = this.toastCtrl.create({
        message: 'fb login check failure: ' + err,
        duration: 1000
      });
      toast.present();
    });
  }

  save(profile){}



}



// WEBPACK FOOTER //
// ./src/providers/user/user.ts